import React, { useState } from "react";
import Select from "./Select";
import { HiOutlineEye, HiOutlineEyeOff } from "react-icons/hi";

const CustomInput = ({
  title,
  value,
  onChange,
  value2,
  onChange2,
  placeholder,
  inputType,
  required,
  customMaxW,
  selectProps,
  disabled,
}) => {
  const [localType, setLocalType] = useState(inputType);
  return (
    <div
      className={`${customMaxW ? customMaxW : ""} w-full flex flex-col p-2  `}
    >
      <div className="flex relative">
        <div className="flex flex-row absolute left-[14px] bg-white top-[-12px] text-cs p-1 pt-0 pb-0 ">
          <span className="whitespace-nowrap font-poppins font-bold text-dark-green">
            {title}
            {required == true && " *"}
          </span>
        </div>
      </div>
      <div
        className={`border-[1px]  border-accent-green rounded-[7px] ${
          inputType == "duration" ? "p-4" : "py-1 px-2"
        } w-full`}
      >
        {inputType == "duration" ? (
          <>
            <input
              className=" focus:ring-transparent w-[60px] border-none px-[10px] py-0 my-0 shadow-inner outline-none bg-[#fcfcfc] rounded-[5px] font-poppins mr-1"
              value={value}
              onChange={onChange}
              placeholder="m"
              type="number"
              min="0"
              required={required}
              disabled={disabled}
            ></input>
            :
            <input
              className=" focus:ring-transparent w-[60px] border-none px-[10px] py-0 my-0  shadow-inner outline-none bg-[#fcfcfc] rounded-[5px] font-poppins ml-1"
              value={value2}
              onChange={onChange2}
              placeholder="s"
              type="number"
              min="0"
              max="59"
              required={required}
              disabled={disabled}
            ></input>
          </>
        ) : inputType == "textarea" ? (
          <textarea
            className="focus:ring-transparent border-none p-[10px] outline-none bg-transparent w-full font-poppins"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type={inputType}
            required={required}
            disabled={disabled}
          />
        ) : inputType == "select" ? (
          <Select {...selectProps} />
        ) : inputType == "password" ? (
          <div className="flex flex-row items-center w-full">
            <input
              className=" focus:ring-transparent border-none p-[10px] pr-0 outline-none bg-transparent font-poppins"
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              type={localType}
              required={required}
              disabled={disabled}
            />

            <span
              className=" hover:bg-light-green cursor-pointer w-[20px] min-h-[1px] flex items-center justify-center relative pl-1"
              onClick={() =>
                setLocalType(localType === "password" ? "text" : "password")
              }
            >
              {value?.trim() === "" && (
                <div className="absolute inset-0 bg-white"></div>
              )}
              {localType === "password" ? (
                <HiOutlineEye className="w-[20px] h-[20px]" />
              ) : (
                <HiOutlineEyeOff className="w-[20px] h-[20px]" />
              )}
            </span>
          </div>
        ) : (
          <input
            className=" focus:ring-transparent border-none p-[10px] outline-none bg-transparent w-full font-poppins"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type={inputType}
            required={required}
            disabled={disabled}
          ></input>
        )}
      </div>
      <div></div>
    </div>
  );
};

export default CustomInput;
